// Mock implementation of base44 client
export const base44 = {
  entities: {
    WebinarConfig: {
      list: async () => {
        const stored = localStorage.getItem('webinar_config');
        return stored ? [JSON.parse(stored)] : [];
      },
      create: async (data: any) => {
        localStorage.setItem('webinar_config', JSON.stringify({ ...data, id: '1' }));
        return { ...data, id: '1' };
      },
      update: async (id: string, data: any) => {
        localStorage.setItem('webinar_config', JSON.stringify({ ...data, id }));
        return { ...data, id };
      }
    },
    WebinarInscricao: {
      list: async (sort?: string) => {
        const stored = localStorage.getItem('webinar_inscricoes');
        const items = stored ? JSON.parse(stored) : [];
        return items.sort((a: any, b: any) => new Date(b.created_date).getTime() - new Date(a.created_date).getTime());
      },
      create: async (data: any) => {
        const stored = localStorage.getItem('webinar_inscricoes');
        const items = stored ? JSON.parse(stored) : [];
        const newItem = { 
          ...data, 
          id: Math.random().toString(36).substr(2, 9),
          created_date: new Date().toISOString()
        };
        items.push(newItem);
        localStorage.setItem('webinar_inscricoes', JSON.stringify(items));
        return newItem;
      },
      update: async (id: string, data: any) => {
        const stored = localStorage.getItem('webinar_inscricoes');
        let items = stored ? JSON.parse(stored) : [];
        items = items.map((item: any) => item.id === id ? { ...item, ...data } : item);
        localStorage.setItem('webinar_inscricoes', JSON.stringify(items));
        return { id, ...data };
      },
      delete: async (id: string) => {
        const stored = localStorage.getItem('webinar_inscricoes');
        if (stored) {
          const items = JSON.parse(stored);
          const filtered = items.filter((item: any) => item.id !== id);
          localStorage.setItem('webinar_inscricoes', JSON.stringify(filtered));
        }
        return { success: true };
      }
    }
  },
  integrations: {
    Core: {
      SendEmail: async (params: any) => {

        return { success: true };
      }
    }
  }
};

